"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries

/* ++++++++++ --------------- SEARCHBAR : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'SearchBar',
  props: {
    type: {
      type: 'string',
      default: 'search'
    },
    name: {
      type: 'string'
    },
    placeholder: {
      type: 'string',
      default: 'Search...'
    },
    value: {
      type: 'string'
    },
    handleFocus: {
      type: 'function',
      default: function _default() {
        return console.log('Focus');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    handleBlur: {
      type: 'function',
      default: function _default() {
        return console.log('Blur');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    onKeyDown: {
      type: 'function',
      default: function _default() {
        return console.log('KeyDown');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    onChange: {
      type: 'function',
      default: function _default() {
        return console.log('Change');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    categories: {
      type: 'object',
      default: [{
        name: "Name1",
        value: "Value1"
      }, {
        name: "Name2",
        value: "Value2"
      }]
    },
    selectCategory: {
      type: 'function',
      default: function _default() {
        return console.log('Selected');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    currentCategory: {
      type: 'object',
      default: {
        name: "Name1",
        value: "Value1"
      }
    }
  }
};
exports.default = _default2;